import { graphql } from '../gql';

export const getSiteDirectionsTokenForUser = graphql(`
  query GetSiteDirectionsTokenForUser($input: GetSiteDirectionsTokenForUser!) {
    getSiteDirectionsTokenForUser(input: $input) {
      error {
        code
        message
      }
      siteDirectionsToken {
        confirmed
        digest
        id
        state
      }
    }
  }
`);
